import { useTranslation } from "react-i18next";

import { NotFoundComponent } from "./components/NotFoundComponent";

export const NotFoundPage = () => {
    const { t } = useTranslation();
    return (
        <NotFoundComponent>
            <h1 className=" text-4xl font-bold text-slate-800">{t("404_title")}!</h1>
        </NotFoundComponent>
    );
};
